import { LoadingButton } from '@mui/lab';
import { Chip, Grid, Typography } from '@mui/material';
import moment from 'moment';
import { useSnackbar } from 'notistack';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { useBookAppointmentMutation } from '../../api/apiSlice';
import Screen from '../../components/fragments/Screen';
import { ListInfo } from '../../tabs/ProfileTab';
import errorSnackbar from '../../utils/errorSnackbar';

export default function AppointmentRouteScreen() {
    const [date_time, setSelectedTime] = useState('');
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();
    const { id } = useParams();
    const state = useSelector((st) => st);

    const [bookAppointment, { isLoading }] = useBookAppointmentMutation();
    const { appointments } = state.list2;

    const { remaining, description, date, venue, name, available } =
        appointments?.find((a) => a.id.toString() === id.toString()) || {};

    const from = moment(available[0]).format('h:mm a');
    const to = moment(available[available.length - 1]).format('h:mm a');
    const duration = `${from} - ${to}`;

    return (
        <Screen title="Appointment">
            <Grid item xs={12}>
                <Typography style={{ marginBottom: 30 }} variant="h5">
                    {name}
                </Typography>

                <Grid container spacing={1}>
                    <ListInfo
                        xs={6}
                        icon="eva:clock-outline"
                        label={duration}
                    />
                    <ListInfo
                        xs={6}
                        icon="eva:calendar-outline"
                        label={moment(date).format('DD MMM YYYY')}
                    />
                    <ListInfo xs={6} icon="eva:pin-outline" label={venue} />
                    {/* <ListInfo
                        xs={6}
                        icon="eva:person-outline"
                        label={'Online session only'}
                    /> */}
                </Grid>
                <Typography sx={{ mt: 4 }}>{description}</Typography>
                <Typography sx={{ mt: 2, mb: 2 }} variant="h6">
                    {remaining} Spaces available
                </Typography>
                {available.map((t) => (
                    <Chip
                        key={t}
                        sx={{ mb: 1, mr: 1 }}
                        color={date_time === t ? 'info' : 'primary'}
                        variant={date_time === t ? 'default' : 'outlined'}
                        onClick={() => setSelectedTime(t)}
                        label={moment(t).format('h:mm a')}
                    />
                ))}
            </Grid>

            <Grid item xs={12}>
                <LoadingButton
                    fullWidth
                    variant="contained"
                    disabled={remaining < 1}
                    loading={isLoading}
                    onClick={async () => {
                        if (date_time === '') {
                            return enqueueSnackbar('Please select a time', {
                                variant: 'error',
                            });
                        }

                        const { data, error } = await bookAppointment({
                            id,
                            date_time,
                        });

                        errorSnackbar(error, enqueueSnackbar);

                        if (data) {
                            enqueueSnackbar('Appointment booked');
                            navigate('/appointments');
                        }
                    }}
                >
                    Book Appointment
                </LoadingButton>
            </Grid>
        </Screen>
    );
}
